// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectRiskWarningMessage } from "../../../../Utils/DirectMessages/DirectRiskWarningMessage.js"
export let RiskWarningMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}
RiskWarningMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

RiskWarningMessageProcessor.prototype.decode = function (fieldSet)
{
    let msg = new DirectRiskWarningMessage();

    let len = fieldSet.Count()
    for (let i = 0; i < len; i++)
    {
        let fixField = fieldSet.fieldSet[i];
        if (fixField.FieldId === 0)
            continue;

        if (fixField.FieldId === FieldsFactory.FIELD_ACCOUNT_ID)
        {
            msg.AccountID = fixField.Value;
        }
        else if (fixField.FieldId === FieldsFactory.FIELD_TEXT)
        {
            msg.Text = fixField.Value;
        }
        else if (fixField.FieldId === FieldsFactory.FIELD_TYPE)
        {
            msg.RiskRuleType = fixField.Value;
        }
        else if (fixField.FieldId === FieldsFactory.FIELD_RISK_WARN_LEVEL)
        {
            msg.RiskWarnLevel = fixField.Value;
        }
    }

    return [msg];
}